module.exports = __webpack_public_path__ + "static/media/06.5fc46424.png";